import { Accessory } from './Accessory';
import { Employee } from './Employee';
import { Load } from './Load';

export enum UnitStatus {
  RESET = 'RESET',
  OFF = 'OFF',
  SCALE = 'SCALE',
  INSPECTION = 'INSPECTION',
  ACCIDENT = 'ACCIDENT',
  FUEL = 'FUEL',
  MAINTENANCE = 'MAINTENANCE',
  EXHANGE = 'EXHANGE',
  BREAKDOWN = 'BREAKDOWN',
  STOP = 'STOP',
  WAITING = 'WAITING',
  DELAY = 'DELAY',
  READY = 'READY',
  LOCATION = 'LOCATION',
}

enum UnitEventAction {
  SUBMIT = 'Submited',
  APPROVE = 'Approved',
  REJECT = 'Rejected',
  EDIT = 'Edited',
  ADD = 'Added',
  REMOVE = 'Removed',
  REQUEST = 'Requested',
  UPDATE = 'Update',
}

export interface UnitEvent {
  timestamp: number;
  status: UnitStatus;
  note?: string;
  user?: string;
  action: UnitEventAction;
  location?: any;
  target?: string;
  source?: string;
}

interface Unit {
  id: string;
  unitId?: string;
  status: UnitStatus;
  drivers: Employee[];
  truck?: any;
  trailer?: any;
  loads: Load[];
  version: number;
  events?: UnitEvent[];
  accessories: {
    [key: string]: Accessory[];
  } | null;
}

export { UnitEventAction };
export type { Unit };
